import { Menu, MenuItem } from '@mui/material';

import useSettings from 'app/main/components/hooks/useSettings';

interface DialogHeaderStyleProps {
	/** The element ref used to show this dialog */
	anchorElement: HTMLButtonElement | null;
	/** True to show the popover component, false to hide it */
	open: boolean;
	/** Function used to close the dialog */
	handleClose: () => void;
	/** Selected header style */
	selectedHeaderStyle: string;
	/** Handler changed header style */
	handleChange: (newStyle: string) => void;
}

/** This dialog is used to expand the HtmlEditor capabilities and add a way to insert working links */
export default function DialogHeaderStyle({
	anchorElement,
	open,
	handleClose,
	selectedHeaderStyle,
	handleChange
}: DialogHeaderStyleProps) {
	const { t } = useSettings();

	const handleClick = headerStyle => {
		handleChange(headerStyle);
		handleClose();
	};

	return (
		<Menu
			anchorEl={anchorElement}
			open={open}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left'
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left'
			}}
		>
			<MenuItem selected={selectedHeaderStyle === 'header-one'} onClick={() => handleClick('header-one')}>
				{t('HTMLEDITOR_H1')}
			</MenuItem>
			<MenuItem selected={selectedHeaderStyle === 'header-two'} onClick={() => handleClick('header-two')}>
				{t('HTMLEDITOR_H2')}
			</MenuItem>
			<MenuItem selected={selectedHeaderStyle === 'header-three'} onClick={() => handleClick('header-three')}>
				{t('HTMLEDITOR_H3')}
			</MenuItem>
			<MenuItem selected={selectedHeaderStyle === 'paragraph'} onClick={() => handleClick('paragraphr')}>
				{t('HTMLEDITOR_P')}
			</MenuItem>
		</Menu>
	);
}
